export const currencyCodes = [
    "GBP", "USD", "EUR", "MOP", "HKD", "CNY", "JPY", "KRW", "SGD", "AUD",
    "CAD", "NZD", "CHF", "SEK", "NOK", "DKK", "PLN", "CZK", "HUF", "RON",
    "BGN", "TRY", "THB", "MYR", "IDR", "PHP", "VND", "TWD", "INR", "AED",
    "SAR", "ZAR", "BRL", "MXN"
];
const currencySymbols = {
    GBP: "£", USD: "$", EUR: "€", MOP: "MOP$", HKD: "HK$", CNY: "¥", JPY: "¥", KRW: "₩",
    SGD: "S$", AUD: "A$", CAD: "C$", NZD: "NZ$", CHF: "CHF", SEK: "kr", NOK: "kr", DKK: "kr",
    PLN: "zł", CZK: "Kč", HUF: "Ft", RON: "lei", BGN: "лв", TRY: "₺", THB: "฿", MYR: "RM",
    IDR: "Rp", PHP: "₱", VND: "₫", TWD: "NT$", INR: "₹", AED: "د.إ", SAR: "﷼", ZAR: "R",
    BRL: "R$", MXN: "MX$"
};
const currencyMinorUnits = {
    GBP: 2, USD: 2, EUR: 2, MOP: 2, HKD: 2, CNY: 2, JPY: 0, KRW: 0, SGD: 2, AUD: 2,
    CAD: 2, NZD: 2, CHF: 2, SEK: 2, NOK: 2, DKK: 2, PLN: 2, CZK: 2, HUF: 2, RON: 2,
    BGN: 2, TRY: 2, THB: 2, MYR: 2, IDR: 2, PHP: 2, VND: 0, TWD: 2, INR: 2, AED: 2,
    SAR: 2, ZAR: 2, BRL: 2, MXN: 2
};
// ISO 3166-1 alpha-2 codes. Display names are generated for the consumer locale.
const regionCodes = "AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW".split(" ");
function displayName(type, code, locale) {
    try {
        const value = new Intl.DisplayNames(locale, { type }).of(code);
        if (value)
            return value;
    }
    catch {
        // Some runtimes do not expose DisplayNames for every requested type.
    }
    return code;
}
export function createCurrencyOptions(locale = "en") {
    return currencyCodes.map((code) => {
        const name = displayName("currency", code, locale);
        return {
            code,
            symbol: currencySymbols[code],
            minorUnit: currencyMinorUnits[code],
            name,
            searchText: `${code} ${currencySymbols[code]} ${name}`.toLocaleLowerCase(locale)
        };
    });
}
export function createRegionOptions(locale = "en") {
    return regionCodes.map((code) => {
        const name = displayName("region", code, locale);
        return {
            code,
            name,
            searchText: `${code} ${name}`.toLocaleLowerCase(locale)
        };
    });
}
export function isCurrencyCode(value) {
    return currencyCodes.includes(value);
}
export function isRegionCode(value) {
    return regionCodes.includes(value.toUpperCase());
}
/** Return a Unicode regional-indicator flag for an ISO 3166-1 alpha-2 code. */
export function regionFlag(code) {
    const normalized = code.trim().toUpperCase();
    if (!/^[A-Z]{2}$/.test(normalized) || !isRegionCode(normalized))
        return "";
    return [...normalized].map((letter) => String.fromCodePoint(0x1f1e6 + letter.charCodeAt(0) - 65)).join("");
}
